"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InviteState;
(function (InviteState) {
    InviteState["INVITED"] = "INVITED";
    InviteState["ACCEPTED"] = "ACCEPTED";
    InviteState["DECLINED"] = "DECLINED";
})(InviteState = exports.InviteState || (exports.InviteState = {}));
function isInviteState(object) {
    return typeof (object) === "string" && Object.values(InviteState).includes(object);
}
exports.isInviteState = isInviteState;
//# sourceMappingURL=InviteState.js.map